import React, { type ComponentProps, useMemo } from 'react'

import { Badge } from 'slab'

import { PRODUCT_CATEGORIES } from '../../../marketplace/shared'
import { type MarketplaceProductCategory } from '../../../marketplace/shared/types'

interface MarketplaceProductBadgeProps {
  category: MarketplaceProductCategory
}

type IconProp = ComponentProps<typeof Badge>['leftIcon']

const MarketplaceProductBadge: React.FC<MarketplaceProductBadgeProps> = ({ category }) => {
  const icon = useMemo(() => {
    let icon: IconProp | undefined

    for (const c of PRODUCT_CATEGORIES) {
      if (c.category === category) {
        icon = c.Icon as IconProp
        break
      }

      // Fallback to All category if no match is found
      if (c.category === 'All') {
        icon = c.Icon as IconProp
      }
    }

    return icon
  }, [category])

  return (
    <div className='whitespace-nowrap'>
      <Badge
        type='thatch'
        bordered
        leftIcon={icon}
      >
        <span className='font-light'>{category}</span>
      </Badge>
    </div>
  )
}

export default MarketplaceProductBadge
